export const PAGINATION_CHANGE_PAGE = 'PAGINATION_CHANGE_PAGE';
export const PAGINATION_LOAD_MORE = 'PAGINATION_LOAD_MORE';



// WEBPACK FOOTER //
// ./constEvents.js